<template lang="pug">
div.dropdown-currency-icon(:class="iconClass")
  .dropdown-currency-icon__circle
    template(v-if="currency === 'BTC'")
      img(src="./currency/bitcoin.svg" width="25" height="25")
    template(v-if="currency === 'USDT'")
      img(src="./currency/usdtether.svg" width="21" height="21")
    template(v-if="currency === 'USDTt'")
      img(src="./currency/usdtether.svg" width="21" height="21")
    template(v-if="currency === 'USDC'")
      img(src="./currency/usdcoin.svg" width="28" height="28")
    template(v-if="currency === 'RUR'")
      img(src="./currency/rouble.svg" width="22" height="22")
    template(v-if="currency === 'EUR'")
      img(src="./currency/euro.svg" width="20" height="20" style="margin-right: 4px;")
    template(v-if="currency === 'ETH'")
      img(src="./currency/ethereum.svg" width="24" height="24")
    template(v-if="currency === 'USD'")
      img(src="./currency/dollar.svg" width="21" height="21")
</template>

<script lang="ts">
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component({
  name: 'dropdown-account-currency-icon',
})
export default class DropdownAccountCurrencyIcon extends Vue {
  @Prop({ required: true })
  currency: string

  get iconClass() {
    return {
      [`dropdown-currency-icon__${this.currency.toLowerCase()}`]: this.currency,
    };
  }
}
</script>

<style scoped lang="less">
@import "../../../../src/assets/capitalist-config";

.dropdown-currency-icon {
  display: inline-block;
  font-size: 90%;

  color: #fff;
  line-height: 1em;

  .dropdown-currency-icon__circle {
    height: 36px;
    width: 36px;
    border-radius: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 8px;  background: #777777;

  }
  &__ {
    &usdt .dropdown-currency-icon__circle {
      background: @colorCurrencyUSDT;
      color: #fff;
    }
    &usdtt .dropdown-currency-icon__circle {
      background: @colorCurrencyUSDT;
      color: #fff;
    }
    &btc .dropdown-currency-icon__circle {
      background: @colorCurrencyBTC;
      color: #fff;
    }
    &eth .dropdown-currency-icon__circle {
      background: @colorCurrencyETH;
      color: #fff;
    }
    &usdc .dropdown-currency-icon__circle {
      background: @colorCurrencyUSDC;
      color: #fff;
    }
    &usd .dropdown-currency-icon__circle {
      background: @colorCurrencyUSD;
      color: #fff;
    }
    &eur .dropdown-currency-icon__circle {background: @colorCurrencyEUR;
      color: #fff;}
    &rur .dropdown-currency-icon__circle {background: @colorCurrencyRUR;
      color: #fff;}
  }
}
</style>
